import React, { FunctionComponent, memo, useLayoutEffect, useRef } from 'react'

import { Button, ButtonSize, ButtonVariant } from '@/atoms/button'

import { StyledComment, StyledInput } from './atoms'

interface Props {
  id: string
  value: string
  placeholder?: string
  hasError?: boolean
  buttonText: string
  loading: boolean
  disabled?: boolean
}

const MIN_TEXTAREA_HEIGHT = 32

const CommentInput: FunctionComponent<Props> = ({ id, value, placeholder, hasError, buttonText, loading, disabled, ...rest }) => {
  const textareaRef = useRef(null)

  useLayoutEffect(() => {
    // Reset height - important to shrink on delete
    textareaRef.current.style.height = '32px'
    // Set height
    textareaRef.current.style.height = `${Math.max(textareaRef.current.scrollHeight, MIN_TEXTAREA_HEIGHT)}px`
  }, [value])

  return (
    <StyledComment $hasError={hasError}>
      <StyledInput id={id} $error={hasError} ref={textareaRef} as="textarea" value={value || ''} placeholder={placeholder} {...rest} />
      {value && (
        <Button
          variant={ButtonVariant.FLAT}
          size={ButtonSize.SMALL}
          disabled={loading || disabled || hasError}
          loading={loading}
          type="submit"
        >
          {buttonText}
        </Button>
      )}
    </StyledComment>
  )
}

CommentInput.displayName = 'CommentInput'

export default memo(CommentInput)
